import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-[80vh] w-full relative">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
